import { render, staticRenderFns } from "./CPPortalNotification.vue?vue&type=template&id=36d5e43f&scoped=true&"
import script from "./CPPortalNotification.vue?vue&type=script&lang=ts&"
export * from "./CPPortalNotification.vue?vue&type=script&lang=ts&"
import style0 from "./CPPortalNotification.vue?vue&type=style&index=0&id=36d5e43f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5e43f",
  null
  
)

export default component.exports